import React from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import LoadingButton from "../../components/LoadingButton";
import LoadingButtonWithForm from "../../components/LoadingButtonWithForm";

const Filter = ({ setQuery }) => {
  const {
    control,
    handleSubmit,
    reset,
  } = useForm();

  const onSubmit = (data) => {
    // clean query object
    const query = {};

    if (data.year && data.year !== "ALL") {
      query.year = data.year;
    }

    if (data.status && data.status !== "ALL") {
      query.status = data.status;
    }

    setQuery(Object.keys(query).length ? query : null);
  };

  return (
    <div className="p-4">
      <Form
        className="row align-items-end"
        onSubmit={handleSubmit(onSubmit)}
        id="filter-management"
      >
        {/* Year Filter */}
        <div className="col-lg-4">
          <Form.Group>
            <Form.Label>Year</Form.Label>
            <Controller
              name="year"
              control={control}
              defaultValue="ALL"
              render={({ field }) => (
                <Form.Select {...field}>
                  <option value="ALL">All Years</option>
                  {Array.from({ length: 7 }, (_, i) => 2024 + i).map(
                    (year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    )
                  )}
                </Form.Select>
              )}
            />
          </Form.Group>
        </div>

        {/* Status Filter */}
        <div className="col-lg-4">
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Controller
              name="status"
              control={control}
              defaultValue="ALL"
              render={({ field }) => (
                <Form.Select {...field}>
                  <option value="ALL">All</option>
                  <option value="IN_PROGRESS">In Progress</option>
                  <option value="COMPLETED">Completed</option>
                </Form.Select>
              )}
            />
          </Form.Group>
        </div>

        {/* Reset */}
        <div className="col-lg-2 col-md-4">
          <LoadingButton
            name="Reset"
            className="w-100"
            type="button"
            onClick={() => {
              reset({
                year: "ALL",
                status: "ALL",
              });
              setQuery(null);
            }}
          />
        </div>

        {/* Apply Filter */}
        <div className="col-lg-2 col-md-4">
          <LoadingButtonWithForm
            name="Filter"
            form="filter-management"
            className="w-100"
          />
        </div>
      </Form>
    </div>
  );
};

export default Filter;
